import { Typography } from "@mui/material";
import React from "react";
import theme from "../../theme/theme";

const MeetingDescription = ({ description }) => {
  return (
    <Typography
      variant="body1"
      sx={{
        color: theme.palette.gray.main,
        marginBottom: "1rem",
        // Show the full description: preserve the line breaks the user typed
        // and break long unbroken strings so nothing overflows its container.
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      }}
    >
      {description}
    </Typography>
  );
};

export default MeetingDescription;
